import { ref } from "vue";

export function useSearch(context, searchTermInternal, dynamic, disabled, searchReactiveCallback) {
    const hasTerm = ref(Boolean(searchTermInternal.value));

    function setSearchTerm(value, skipEmit) {
        searchTermInternal.value = value;
        if (skipEmit) {
            return;
        }
        if (dynamic.reactive) {
            debounce(search, dynamic.debounce)();
        }
    }

    function search(callback) {
        if (!disabled) {
            hasTerm.value = searchTermInternal.value !== "";
            if (callback && typeof callback === "function") {
                callback();
            }
        }
    }

    function debounce(func, wait) {
        let timeout;
        return function () {
            const delay = function () {
                func.apply(context, [searchReactiveCallback]);
            };
            clearTimeout(timeout);
            timeout = setTimeout(delay, wait);
        };
    }

    return {
        //refs
        hasTerm,
        //methods
        setSearchTerm,
        search,
        debounce
    };
}
